// extracted by mini-css-extract-plugin
export default {"form":"SL4xT70kDtMw7ylnqWUg","submit":"DNC9wNO3eEJvZcu3CkWq","back":"Xmwc6pbt6jeF0H7Jybjr","placeHolderShimmer":"pMcN2QWhsdTHdyzTL9DI"};